// extracted by mini-css-extract-plugin
export default {"root":"_1UyRP","image":"llprG","large":"_2vJTn","medium":"xzDZx","small":"_3jfD1"};